var Handlebars = require("../../../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "checked";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "\n<label class=\"\">\n    <input type=\"checkbox\" class=\"existing-wc-checkbox\" "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.useNewValues : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ">\n    Update Existing Tokens With Current Values\n</label>\n<i class=\"icon-info-circled existing-token-icon\" title=\""
    + container.escapeExpression(((helper = (helper = helpers.message || (depth0 != null ? depth0.message : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"message","hash":{},"data":data}) : helper)))
    + "\"></i>\n\n\n\n\n\n\n";
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/views/note/textStamp/existingTokens/template.hbs
 ** module id = 333
 ** module chunks = 0
 **/